<script>
export default {
  name: 'PersistentConfirmationsAddress',

  functional: true,

  props: {
    data: {
      type: Object,
      required: false,
      default: null,
    },
  },

  render: (h, ctx) => {
    const { data } = ctx.props;
    const bpi = data?.businessPartnerInformation && data.businessPartnerInformation[0];
    if (bpi) {
      const address = [];
      if (data.name) {
        address.push(data.name);
        address.push(h('br'));
      }
      if (bpi.street && bpi.streetNumber) {
        address.push(bpi.street + ' ' + bpi.streetNumber);
        address.push(h('br'));
      } else if (bpi.street) {
        address.push(bpi.street);
        address.push(h('br'));
      }
      if (bpi.zipCode && bpi.city) {
        address.push(bpi.zipCode + ' ' + bpi.city);
      } else if (bpi.zipCode) {
        address.push(bpi.zipCode);
      } else if (bpi.city) {
        address.push(bpi.city);
      }

      return address;
    }

    if (data?.factoringInformation) {
      const ret = [];
      for (let i = 1; i < 5; i++) {
        const key = `address${i}`;
        if (!data.factoringInformation[key]) break;
        ret.push(data.factoringInformation[key]);
        ret.push(h('br'));
      }
      return ret;
    }

    return null;
  },
};
</script>
